import { defaultApiState } from '../api.state';

export const helloDnaProfileMutations = {
  GET_HELLO_DNA_PROFILES_LOADING(state) {
    state.apiState.getHelloDnaProfiles = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_HELLO_DNA_PROFILES_SUCCESS(state, payload) {
    state.apiState.getHelloDnaProfiles = {
      ...defaultApiState,
      success: true,
    };
    state.helloDnaProfiles = payload;
  },
  GET_HELLO_DNA_PROFILES_ERROR(state, error) {
    state.apiState.getHelloDnaProfiles = {
      ...defaultApiState,
      error,
    };
  },
  GET_HELLO_DNA_PROFILE_LOADING(state) {
    state.apiState.getHelloDnaProfile = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_HELLO_DNA_PROFILE_SUCCESS(state, payload) {
    state.apiState.getHelloDnaProfile = {
      ...defaultApiState,
      success: true,
    };
    state.helloDnaProfile = payload;
  },
  GET_HELLO_DNA_PROFILE_ERROR(state, error) {
    state.apiState.getHelloDnaProfile = {
      ...defaultApiState,
      error,
    };
  },
  UPDATE_HELLO_DNA_PROFILE_LOADING(state) {
    state.apiState.updateHelloDnaProfile = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_HELLO_DNA_PROFILE_SUCCESS(state, payload) {
    state.apiState.updateHelloDnaProfile = {
      ...defaultApiState,
      success: true,
    };
    state.helloDnaProfile = payload;
  },
  UPDATE_HELLO_DNA_PROFILE_ERROR(state, error) {
    state.apiState.updateHelloDnaProfile = {
      ...defaultApiState,
      error,
    };
  },
  BATCH_UPDATE_HELLO_DNA_PROFILE_LOADING(state) {
    state.apiState.batchUpdateHelloDnaProfile = {
      ...defaultApiState,
      loading: true,
    };
  },
  BATCH_UPDATE_HELLO_DNA_PROFILE_SUCCESS(state, payload) {
    state.apiState.batchUpdateHelloDnaProfile = {
      ...defaultApiState,
      success: true,
    };
    state.helloDnaProfile = payload;
  },
  BATCH_UPDATE_HELLO_DNA_PROFILE_ERROR(state, error) {
    state.apiState.batchUpdateHelloDnaProfile = {
      ...defaultApiState,
      error,
    };
  },
  UPLOAD_HELLO_DNA_REPORT_LOADING(state) {
    state.apiState.uploadHelloDnaReport = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPLOAD_HELLO_DNA_REPORT_SUCCESS(state, payload) {
    state.apiState.uploadHelloDnaReport = {
      ...defaultApiState,
      success: true,
    };
    state.helloDnaProfile = payload;
  },
  UPLOAD_HELLO_DNA_REPORT_ERROR(state, error) {
    state.apiState.uploadHelloDnaReport = {
      ...defaultApiState,
      error,
    };
  },
};
